module.exports = __webpack_public_path__ + "static/media/icon_footer_instagramn.a8559235.svg";